import { Component, OnInit } from '@angular/core';
import { APIService } from '../shared/service/api.service';

@Component({
  selector: 'app-todas-edicoes',
  templateUrl: './todas-edicoes.component.html',
  styleUrls: ['./todas-edicoes.component.scss']
})
export class TodasEdicoesComponent implements OnInit {
  location = window.location.host;
  downloadCatalogoPdf = `/cnct-api/catalogopdf`;
  downloadAtuslizacaoPortalPdf = '/cnct-api/relatorio-dados-atualizadospdf';
  encoding = 'ISO-8859-1';

  constructor(private api: APIService) { }

  ngOnInit(): void {
  }


  downloadCsvCatalogoCnct(event: MouseEvent) {
    event.preventDefault();

    this.api.getDownloadCsvCatalogoCnct(this.encoding)
      .subscribe((data: any) => {
        const blob = new Blob([data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'catalogo_cnct.csv';
        link.click();
      },
        (error) => {
          console.error('Erro ao baixar o CSV de catálogo do Cnct.', error);

        });
  }

}
